import { useState, useEffect } from 'react';
import toBaseLocale from '../utils/toBaseLocale.esm.js';
import useLocalization from './useLocalization.esm.js';

const usePageTranslations = ()=>{
    const { currentLocale, localeLabels, translations = [], onChangeLocale } = useLocalization();
    const [data, setData] = useState(undefined);
    useEffect(()=>{
        if (currentLocale) {
            const switcherData = {
                currentLocale: {
                    locale: toBaseLocale(currentLocale),
                    localeLabel: localeLabels[currentLocale]
                },
                translations: translations.map((t)=>({
                        locale: toBaseLocale(t.locale),
                        localeLabel: localeLabels[t.locale],
                        url: t.url
                    }))
            };
            setData(switcherData);
        }
    }, [
        currentLocale,
        translations
    ]);
    return [
        data,
        {
            onChangeLocale
        }
    ];
};

export { usePageTranslations as default };
